import React, { useEffect, useReducer } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import _ from "lodash";
import moment from "moment";
import tw from "tailwind-styled-components";
import { RotatingLines } from "react-loader-spinner";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import Checkbox from "@mui/material/Checkbox";
import Autocomplete from "@mui/material/Autocomplete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ClubDetails } from "@containers";
import { get, set, remove } from "@utils";
import { PrimaryText, TostMessage } from "@components";
import {
  isModal,
  payLoader,
  getCounty,
  getBookingData,
  getListingBookings,
  createPaymentIntent,
} from "@store";
import SuccessModal from "./successModal";
import PaymentDetails from "./paymentDetails";
import PrivacyPolicyModal from "./privacyPolicy";
import TermAndConditionModal from "./termAndConditionModal";
import Config from "../../../config";

const stripePromise = loadStripe(Config.STRIPE_PUBLISH_KEY);

function CheckOutForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation("common");
  const playersPriceList = location.state;
  const userStatus = useSelector((state) => state.users.status);
  const countriesList = useSelector((state) => state.setting.county);
  const paymentLoader = useSelector((state) => state.payment.payLoader);
  const facilitiesDetails = useSelector(
    (state) => state.facilities.facilitiesData
  );
  const clubData = useSelector((state) => state.clubs.clubsData);
  const facilitiesData = clubData?.data?.facility;

  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      email: "",
      county: "",
      lastName: "",
      handicap: "",
      firstName: "",
      telePhone: "",
      cdhNumber: "",
      player2Name: "",
      player3Name: "",
      player4Name: "",
      country: { label: "Ireland" },
      club: "Santo da Serra",
      player4Handicap: "",
      player3Handicap: "",
      specialRequests: "",
      player2Handicap: "",
      player3CDHNumber: "",
      player4CDHNumber: "",
      player2CDHNumber: "",
      countyList: [],
      countryList: [],
      userData: null,
      checkBox: false,
      payClick: false,
      countryDropdown: false,
      torunamentId: null,
      successModal: false,
      alertMessage: false,
      tournamentData: null,
      alertMessageTxt: null,
      bookingListPayload: [],
      paymentCondition: null,
      player2SwitchBtn: true,
      player3SwitchBtn: true,
      player4SwitchBtn: true,
      teeTimeISBooked: false,
      isPaymentApplicable: true,
      privacyPolicyModal: false,
      termConditionModal: false,
    }
  );

  const prices = playersPriceList?.length
    ? playersPriceList?.map((a) => a?.activePrice)
    : "";
  const totalPrice = playersPriceList?.length
    ? prices?.reduce((acc, curr) => acc + curr)
    : "";

  const paymentOptions = {
    mode: "payment",
    amount: 1099,
    currency: "usd",
    appearance: {
      rules: {
        ".Label": {
          color: "#ffffffb3",
        },
      },
    },
  };

  const theme = createTheme({
    palette: {
      success: {
        main: "#ffffff",
      },
      secondary: {
        main: "#ffffff",
      },
    },
  });

  useEffect(() => {
    dispatch(getCounty());
    fillUserDetail();
  }, []);

  useEffect(() => {
    let countrylist = [];
    let countriesCounty;
    if (countriesList?.data?.length) {
      countriesList?.data?.map((res) => {
        countrylist?.push({ label: res?.countryName });
      });
      countriesCounty = countriesList?.data?.find((e) => {
        return e?.countryName === state.country?.label;
      });
      let countylist = [];
      if (countriesCounty?.counties?.length) {
        countriesCounty?.counties?.map((res) => {
          countylist?.push({ label: res?.title });
        });
        setState({ countyList: countylist, county: countylist[0] });
      } else {
        setState({ countyList: [], county: "" });
      }
    }
    setState({ countryList: countrylist });
  }, [countriesList, state.country]);

  const fillUserDetail = () => {
    const localUsers = localStorage.getItem("localUserData");
    if (localUsers === null) {
    } else {
      let data = JSON.parse(localUsers);
      setState({
        email: data?.email,
        handicap: data?.handicap,
        lastName: data?.lastName,
        checkBox: data?.checkBox,
        cdhNumber: data?.cdhNumber,
        firstName: data?.firstName,
        telePhone: data?.telePhone,
        player2Name: data?.player2Name,
        player3Name: data?.player3Name,
        player4Name: data?.player4Name,
        player2Handicap: data?.player2Handicap,
        player3Handicap: data?.player3Handicap,
        player4Handicap: data?.player4Handicap,
        specialRequests: data?.specialRequests,
        player2CDHNumber: data?.player2CDHNumber,
        player3CDHNumber: data?.player3CDHNumber,
        player4CDHNumber: data?.player4CDHNumber,
      });
    }
  };

  useEffect(() => {
    const tournamentDetails = get("CompetitonBookData");
    if (tournamentDetails !== null) {
      const data = JSON.parse(get("CompetitonBookData"));
      setState({
        tournamentData: data?.competitonBookData,
        tournamentId: data?.competitonBookData?.tournamentId,
      });

      let selectedPlayer = data?.competitonBookData?.slot?.id;
      let selectedDate = data?.competitonBookData?.teeTime?.time;
      var bookingsApiData = {
        fromDate: moment(selectedDate).subtract(1, "day").format("DD-MM-YYYY"),
        toDate: moment(selectedDate).add(1, "day").format("DD-MM-YYYY"),
      };
      dispatch(getListingBookings(bookingsApiData)).then((res) => {
        if (res?.payload?.data?.data?.data && res?.payload?.status === 200) {
          let listingData = res?.payload?.data?.data?.data;

          const bookedTeeTime = _.filter(listingData, function (e) {
            return (
              e?.teeId === data?.competitonBookData?.teeTime?.id &&
              e?.teetime === selectedDate &&
              e?.course === data?.competitonBookData?.teeTime?.course &&
              e?.status === "BOOKED" &&
              4 - e?.players < selectedPlayer
            );
          });
          if (bookedTeeTime?.length) {
            setState({ teeTimeISBooked: true });
          } else {
            setState({ teeTimeISBooked: false });
          }
        } else {
          setState({ teeTimeISBooked: false });
        }
      });
    }
  }, []);

  useEffect(() => {
    if (facilitiesDetails?.data?.length) {
      facilitiesDetails?.data.map((item, index) => {
        if (item?.paymentRule) {
          setState({
            paymentCondition: item?.paymentRule,
            isPaymentApplicable: item?.applicableForWhitelable,
          });
        }
      });
    }
  }, [facilitiesDetails]);

  useEffect(() => {
    const users = localStorage.getItem("UserData");
    if (users === null) {
      setState({ userData: null });
    } else {
      setState({ userData: JSON.parse(users) });
    }
  }, [userStatus]);

  useEffect(() => {
    if (state.userData != null) {
      setState({
        firstName: state.userData?.user?.firstName,
        lastName: state.userData?.user?.lastName,
        email: state.userData?.user?.email,
        telePhone: state.userData?.user?.phone,
      });
    }
  }, [state.userData]);

  useEffect(() => {
    if (state.player2SwitchBtn) {
      setState({
        player2Name: state.lastName
          ? state.firstName + " " + state.lastName + " " + " Guest1"
          : state.firstName + " " + "Guest1",
      });
    } else {
      setState({
        player2Name: "",
      });
    }
  }, [state.player2SwitchBtn, state.firstName, state.lastName]);

  useEffect(() => {
    if (state.player3SwitchBtn) {
      setState({
        player3Name: state.lastName
          ? state.firstName + " " + state.lastName + " " + " Guest2"
          : state.firstName + " " + " Guest2",
      });
    } else {
      setState({
        player3Name: "",
      });
    }
  }, [state.player3SwitchBtn, state.firstName, state.lastName]);

  useEffect(() => {
    if (state.player4SwitchBtn) {
      setState({
        player4Name: state.lastName
          ? state.firstName + " " + state.lastName + " " + " Guest3"
          : state.firstName + " " + " Guest3",
      });
    } else {
      setState({
        player4Name: "",
      });
    }
  }, [state.player4SwitchBtn, state.firstName, state.lastName]);

  useEffect(() => {
    let player1Detail = {
      contactFirstName: state.firstName,
      contactLastName: state.lastName,
      teeId: state.tournamentData?.teeTime?.id,
      course: state.tournamentData?.data?.courseId?.courseName,
      players: 1,
      teetime: moment(state.tournamentData?.teeTime?.time).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      holes: state.tournamentData?.teeTime?.holes,
      netRate: playersPriceList[0]?.activePrice,
      playerType:
        playersPriceList[0]?.playerTypeId ||
        "1e7bdd4b-c3da-4595-999b-d9c31067039c",
    };
    let player2Detail = {
      contactFirstName: state.player2Name,
      contactLastName: "",
      teeId: state.tournamentData?.teeTime?.id,
      course: state.tournamentData?.data?.courseId?.courseName,
      players: 1,
      teetime: moment(state.tournamentData?.teeTime?.time).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      holes: state.tournamentData?.teeTime?.holes,
      netRate: playersPriceList[1]?.activePrice,
      playerType:
        playersPriceList[1]?.playerTypeId ||
        "1e7bdd4b-c3da-4595-999b-d9c31067039c",
    };
    let player3Detail = {
      contactFirstName: state.player3Name,
      contactLastName: "",
      teeId: state.tournamentData?.teeTime?.id,
      course: state.tournamentData?.data?.courseId?.courseName,
      players: 1,
      teetime: moment(state.tournamentData?.teeTime?.time).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      holes: state.tournamentData?.teeTime?.holes,
      netRate: playersPriceList[2]?.activePrice,
      playerType:
        playersPriceList[2]?.playerTypeId ||
        "1e7bdd4b-c3da-4595-999b-d9c31067039c",
    };
    let player4Detail = {
      contactFirstName: state.player4Name,
      contactLastName: "",
      teeId: state.tournamentData?.teeTime?.id,
      course: state.tournamentData?.data?.courseId?.courseName,
      players: 1,
      teetime: moment(state.tournamentData?.teeTime?.time).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      holes: state.tournamentData?.teeTime?.holes,
      netRate: playersPriceList[3]?.activePrice,
      playerType:
        playersPriceList[3]?.playerTypeId ||
        "1e7bdd4b-c3da-4595-999b-d9c31067039c",
    };
    let playerArr = [];

    if (state.tournamentData?.slot?.id === 1) {
      playerArr = [player1Detail];
    } else if (state.tournamentData?.slot?.id === 2) {
      playerArr = [player1Detail, player2Detail];
    } else if (state.tournamentData?.slot?.id === 3) {
      playerArr = [player1Detail, player2Detail, player3Detail];
    } else {
      playerArr = [player1Detail, player2Detail, player3Detail, player4Detail];
    }

    setState({ bookingListPayload: playerArr });
  }, [
    playersPriceList,
    state.tournamentData,
    state.firstName,
    state.lastName,
    state.player2Name,
    state.player3Name,
    state.player4Name,
  ]);

  useEffect(() => {
    if (state.successModal) {
      dispatch(isModal(true));
    } else {
      dispatch(isModal(false));
    }
  }, [state.successModal]);

  const changePlayer2SwitchBtn = (event) => {
    setState({ player2SwitchBtn: event.target.checked });
  };
  const changePlayer3SwitchBtn = (event) => {
    setState({ player3SwitchBtn: event.target.checked });
  };
  const changePlayer4SwitchBtn = (event) => {
    setState({ player4SwitchBtn: event.target.checked });
  };

  const closeTermConditionModal = () => {
    setState({ termConditionModal: false });
  };
  const closePrivacyPolicyModal = () => {
    setState({ privacyPolicyModal: false });
  };

  const cancle = () => {
    setState({
      firstName: "",
      lastName: "",
      email: "",
      telePhone: "",
    });
    navigate("/tournament");
  };

  const submitOk = (e) => {
    e.preventDefault();
    if (state.checkBox) {
      if (state.teeTimeISBooked) {
        setState({
          alertMessage: true,
          alertMessageTxt:
            "This teetimes is booked by some one please try again with another tee time !",
        });
      } else {
        if (
          state.paymentCondition?.firstPaymentCondition === "Invoice" ||
          !state.isPaymentApplicable
        ) {
          dispatch(payLoader(true));

          const bookingApiData = {
            bookings: state.bookingListPayload,
            facilityId: facilitiesData?.id,
            contactPhone: state.telePhone,
            contactEmail: state.email,
            amountPaid: totalPrice,
            clubPhone: clubData?.data
              ? clubData?.data?.phone
              : "",
            contactFirstName: state.firstName,
            contactLastName: state.lastName,
          };
          dispatch(getBookingData(bookingApiData)).then(async (res) => {
            if (
              res?.payload?.data &&
              res?.payload?.status === 200 &&
              res?.payload?.data?.data?.bulkBookingId
            ) {
              let paymentApiData = {
                name: state?.firstName + " " + state?.lastName,
                email: state?.email,
                currency: "EUR",
                description: state?.specialRequests
                  ? state?.specialRequests
                  : "Booking open-competition Tee-Time",
                customer: res?.payload?.data?.id,
                bookingPayment: state?.bookingListPayload,
                facilityId: facilitiesData?.id,
                country: state?.country?.label,
                county: state?.county?.label,
                handicap: state?.handicap,
                cdhNumber: state?.cdhNumber,
              };

              let mergeArray = paymentApiData?.bookingPayment?.map((item, i) =>
                Object.assign({}, item, res?.payload?.data?.data?.bookingIds[i])
              );
              let deleteTeetime = mergeArray?.map(function (item) {
                delete item?.teetime;
                return item;
              });
              paymentApiData.bookingPayment = deleteTeetime;
              paymentApiData.bulkBookingId =
                res?.payload?.data?.data?.bulkBookingId;
              await createPayment(paymentApiData);
            } else {
              dispatch(payLoader(false));
              res?.payload?.data?.raw?.message
                ? setState({
                    alertMessage: true,
                    alertMessageTxt: res?.payload?.data?.raw?.message,
                  })
                : res?.payload?.response?.data?.error?.message
                ? setState({
                    alertMessage: true,
                    alertMessageTxt:
                      res?.payload?.response?.data?.error?.message,
                  })
                : res?.payload?.response?.data?.message
                ? setState({
                    alertMessage: true,
                    alertMessageTxt: res?.payload?.response?.data?.message,
                  })
                : setState({
                    alertMessage: true,
                    alertMessageTxt:
                      "A generic error occurred on the Tournament Booking !",
                  });
            }
          });
        } else {
          setState({ payClick: true });
        }
      }
    }
  };

  const createPayment = async (apiData) => {
    await dispatch(createPaymentIntent(apiData)).then((res) => {
      dispatch(payLoader(false));
      setState({ successModal: true });
    });
  };

  const closeSuccessModal = () => {
    setState({ successModal: false });
    navigate(-2);
    remove("localUserData");
  };

  const saveDetails = () => {
    let localUserData = {
      email: state.email,
      lastName: state.lastName,
      checkBox: state.checkBox,
      handicap: state.handicap,
      firstName: state.firstName,
      telePhone: state.telePhone,
      cdhNumber: state.cdhNumber,
      player2Name: state.player2Name,
      player3Name: state.player3Name,
      player4Name: state.player4Name,
      player2Handicap: state.player2Handicap,
      player3Handicap: state.player3Handicap,
      player4Handicap: state.player4Handicap,
      specialRequests: state.specialRequests,
      player2CDHNumber: state.player2CDHNumber,
      player3CDHNumber: state.player3CDHNumber,
      player4CDHNumber: state.player4CDHNumber,
    };
    set("localUserData", JSON.stringify(localUserData));
  };

  const CustomInput = (props) => {
    return (
      <div className="w-full ">
        <label className="text-[15px] text-white255a font-[Cambay] mb-1 flex flex-row">
          {props.title}{" "}
          {props.optional ? (
            <span className="text-[#ffffff7a] text-sm font-[Cambay]">
              {"(optional)"}
            </span>
          ) : (
            ""
          )}
          {props.require ? (
            <Tooltip title={`Please fill in this field.`} arrow>
              <div className="cursor-pointer">
                <span className="text-[#ff6d6d] text-sm pl-[1px] font-[Cambay]">
                  {" *"}
                </span>
              </div>
            </Tooltip>
          ) : (
            ""
          )}
        </label>
        <input
          readOnly={props.readOnly}
          placeholder={props.placeholder ? props.placeholder : props.title}
          className={txtInput}
          type={props.type ? props.type : "text"}
          value={props.value}
          onChange={props.onChange}
          maxLength={props.maxLength}
          required={props.require}
          onInvalid={props.onInvalid}
          onInput={(e) => e.target.setCustomValidity("")}
          autoComplete="off"
          role="presentation"
        />
      </div>
    );
  };

  const DetailTxt = (props) => {
    return (
      <div
        className={`w-full h-[48px] flex items-center justify-start px-2 bg-primary rounded-lg `}
      >
        <PrimaryText className={`text-[18px] font-medium text-white `}>
          {props.title}
        </PrimaryText>
      </div>
    );
  };

  const DetailText = (props) => {
    return (
      <div
        className={`w-full h-[48px] flex items-center justify-start px-2 bg-white rounded-lg`}
      >
        <PrimaryText className={`text-[18px] truncate`}>
          {props.title}
        </PrimaryText>
      </div>
    );
  };

  const BookingForm = () => {
    return (
      <>
        <form onSubmit={submitOk}>
          <InputView>
            <div
              className={`${
                playersPriceList?.length === 1 ? "w-full" : "md3:w-[50%] w-full"
              } flex flex-col`}
            >
              <div className="mb-4">
                <PrimaryText className={inputTitle}>
                  {t("tournamentCheckout.player1")}
                </PrimaryText>
              </div>

              <div
                className={
                  playersPriceList?.length === 1
                    ? `w-full h-auto flex md3:flex-row flex-col gap-x-6`
                    : ""
                }
              >
                {CustomInput({
                  title: t("checkOut.completeBooking.fName"),
                  value: state.firstName,
                  onChange: (event) => {
                    const regex = /^[a-zA-Z\b]+$/;
                    if (
                      event.target.value === "" ||
                      regex.test(event.target.value)
                    ) {
                      setState({ firstName: event.target.value });
                      saveDetails();
                    }
                  },
                  maxLength: 30,
                  require: true,
                  onInvalid: (e) => {
                    e.target.setCustomValidity(
                      t("checkOut.completeBooking.enterFName")
                    );
                  },
                })}
                {CustomInput({
                  title: t("checkOut.completeBooking.lName"),
                  value: state.lastName,
                  onChange: (event) => {
                    const regex = /^[a-zA-Z\b]+$/;
                    if (
                      event.target.value === "" ||
                      regex.test(event.target.value)
                    ) {
                      setState({ lastName: event.target.value });
                      saveDetails();
                    }
                  },
                  maxLength: 30,
                  require: true,
                  onInvalid: (e) => {
                    e.target.setCustomValidity(
                      t("checkOut.completeBooking.enterLName")
                    );
                  },
                })}
              </div>
              <div
                className={
                  playersPriceList?.length === 1
                    ? `w-full h-auto flex md3:flex-row flex-col gap-x-6`
                    : ""
                }
              >
                {CustomInput({
                  title: t("checkOut.completeBooking.email"),
                  value: state.email,
                  type: "email",
                  onChange: (event) => {
                    setState({ email: event.target.value });
                    saveDetails();
                  },
                  require: true,
                  onInvalid: (e) => {
                    e.target.setCustomValidity(
                      t("checkOut.completeBooking.enterEmail")
                    );
                  },
                  maxLength: 40,
                })}
                {CustomInput({
                  title: t("tournamentCheckout.mobileNo"),
                  value: state.telePhone,
                  onChange: (event) => {
                    const regex = /^[0-9+-.\b]+$/;
                    if (
                      event.target.value === "" ||
                      regex.test(event.target.value)
                    ) {
                      setState({ telePhone: event.target.value });
                      saveDetails();
                    }
                  },
                  maxLength: 30,
                  require: true,
                  onInvalid: (e) => {
                    e.target.setCustomValidity(
                      t("tournamentCheckout.mobileNo")
                    );
                  },
                })}
              </div>
              <div
                className={
                  playersPriceList?.length === 1
                    ? `w-full h-auto flex md3:flex-row flex-col gap-x-6`
                    : ""
                }
              >
                {CustomInput({
                  title: t("tournamentCheckout.handicap"),
                  value: state.handicap,
                  onChange: (event) => {
                    const regex = /^[0-9+-.\b]+$/;
                    if (
                      event.target.value === "" ||
                      regex.test(event.target.value)
                    ) {
                      setState({ handicap: event.target.value });
                      saveDetails();
                    }
                  },
                  maxLength: 5,
                })}
                {CustomInput({
                  title: t("tournamentCheckout.club"),
                  value: state.club,
                  onChange: (event) => {
                    setState({ club: event.target.value });
                  },
                  maxLength: 30,
                  readOnly: true,
                })}
              </div>
              <div
                className={
                  playersPriceList?.length === 1
                    ? `w-full h-auto flex md3:flex-row flex-col gap-x-6`
                    : ""
                }
              >
                <div className="w-full">
                  <label className="text-[15px] text-white255a font-[Cambay] mb-1 flex flex-row">
                    {t("tournamentCheckout.selectContry")}{" "}
                  </label>
                  <Autocomplete
                    className="w-full h-[45px] mb-4"
                    sx={{
                      display: "inline-block",
                      "& input": {
                        bgcolor: "background.paper",
                        color: (theme) =>
                          theme.palette.getContrastText(
                            theme.palette.background.paper
                          ),
                      },
                    }}
                    id="custom-input-demo"
                    options={state.countryList}
                    value={state.country}
                    onChange={(event, newValue) => {
                      setState({ country: newValue, countryDropdown: true });
                      saveDetails();
                    }}
                    onFocus={() => setState({ countryDropdown: true })}
                    onClose={() => setState({ countryDropdown: false })}
                    renderInput={(params) => (
                      <div
                        ref={params.InputProps.ref}
                        className="w-full flex relative"
                      >
                        <input
                          type="text"
                          {...params.inputProps}
                          className={txtInput}
                          style={{ width: "100%" }}
                          placeholder={t("tournamentCheckout.selectContry")}
                          required={true}
                        />
                        <div
                          className={`w-fit h-fit absolute right-0 top-1 ${
                            state.countryDropdown
                              ? "duration-500 transform rotate-180"
                              : "duration-500 transform rotate-0"
                          }`}
                        >
                          <ExpandMoreIcon
                            fontSize="large"
                            sx={{ color: "#757680" }}
                          />
                        </div>
                      </div>
                    )}
                  />
                </div>
                <div className="w-full">
                  <label className="text-[15px] text-white255a font-[Cambay] mb-1 flex flex-row">
                    {t("tournamentCheckout.selectCountie")}{" "}
                  </label>
                  <Autocomplete
                    className="w-full h-[45px] mb-4 "
                    sx={{
                      display: "inline-block",
                      "& input": {
                        bgcolor: "background.paper",
                        color: (theme) =>
                          theme.palette.getContrastText(
                            theme.palette.background.paper
                          ),
                      },
                    }}
                    id="custom-input-demo"
                    options={state.countyList}
                    disabled={state.countyList?.length < 1}
                    value={state.county}
                    onChange={(event, newValue) => {
                      setState({ county: newValue, countyDropdown: true });
                      saveDetails();
                    }}
                    onFocus={() => setState({ countyDropdown: true })}
                    onClose={() => setState({ countyDropdown: false })}
                    renderInput={(params) => (
                      <div
                        ref={params.InputProps.ref}
                        className="w-full flex relative"
                      >
                        <input
                          type="text"
                          {...params.inputProps}
                          style={{ width: "100%" }}
                          className={`${txtInput} ${
                            state.countyList?.length < 1
                              ? "hover:cursor-not-allowed opacity-60"
                              : "hover:cursor-text"
                          }`}
                          placeholder={t("tournamentCheckout.selectCountie")}
                        />
                        {state.countyList?.length > 0 && (
                          <div
                            className={`w-fit h-fit absolute right-0 top-1 ${
                              state.countyDropdown
                                ? "duration-500 transform rotate-180"
                                : "duration-500 transform rotate-0"
                            }`}
                          >
                            <ExpandMoreIcon
                              fontSize="large"
                              sx={{ color: "#757680" }}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  />
                </div>
              </div>
              <div
                className={
                  playersPriceList?.length === 1
                    ? `w-full h-auto flex md3:flex-row-reverse flex-col gap-x-6`
                    : ""
                }
              >
                <div className="w-full"></div>
                {CustomInput({
                  title:
                    state.country?.label === "Ireland"
                      ? t("tournamentCheckout.cdhNo")
                      : "PlayerId",
                  value: state.cdhNumber,
                  onChange: (event) => {
                    setState({ cdhNumber: event.target.value });
                    saveDetails();
                  },
                  maxLength: 25,
                })}
              </div>
              <div
                className={
                  playersPriceList?.length === 1
                    ? `w-full h-auto flex md3:flex-row-reverse flex-col gap-x-6`
                    : ""
                }
              >
                <div className="w-full">
                  <div className="my-4">
                    <PrimaryText className={inputTitle}>
                      {t("checkOut.completeBooking.specialRequest")}
                    </PrimaryText>
                  </div>
                  <textarea
                    value={state.specialRequests}
                    onChange={(event) => {
                      setState({ specialRequests: event.target.value });
                      saveDetails();
                    }}
                    rows={6}
                    placeholder={t("checkOut.completeBooking.insertYour")}
                    className={txtInput}
                  ></textarea>
                </div>
              </div>

              <CheckboxView className="w-auto h-auto flex flex-row items-center">
                <ThemeProvider theme={theme}>
                  <Checkbox
                    required
                    checked={state.checkBox}
                    color="success"
                    sx={{ color: "white" }}
                    onChange={(event) => {
                      setState({ checkBox: event.target.checked });
                    }}
                  />
                </ThemeProvider>
                <PrimaryText className="text-white255 font-[Cambay] font-medium">
                  {t("checkOut.completeBooking.iAgree")}
                  <span
                    className="text-red255 underline font-medium ml-1 hover:cursor-pointer font-[Cambay]"
                    onClick={() => setState({ termConditionModal: true })}
                  >
                    {" "}
                    {t("checkOut.completeBooking.termCondition")}
                  </span>{" "}
                  {t("tournamentCheckout.and")}{" "}
                  <span
                    className="text-red255 underline font-medium ml-1 font-[Cambay] hover:cursor-pointer"
                    onClick={() => setState({ privacyPolicyModal: true })}
                  >
                    {t("checkOut.completeBooking.privacyPolicy")}
                  </span>
                  {"."}
                </PrimaryText>
              </CheckboxView>
            </div>
            {playersPriceList?.length >= 2 && (
              <div className="md3:w-[50%] w-full flex flex-col max-h-[1000px] overflow-y-auto custom-scroll">
                {playersPriceList?.length >= 2 && (
                  <React.Fragment>
                    <div className="mb-4 w-full h-auto flex flex-col md3:mt-0 mt-8">
                      <div className="w-full h-auto flex flex-row gap-x-2 items-center">
                        <PrimaryText className="text-white255 text-lg">
                          {t("tournamentCheckout.sameDetail")}
                        </PrimaryText>
                        <span
                          className={`${
                            state.player2SwitchBtn ? "hidden" : "flex"
                          } text-white255 text-md ml-[10px] mr-[-13px] font-[Cambay]`}
                        >
                          {"off"}
                        </span>
                        <ThemeProvider theme={theme}>
                          <Switch
                            checked={state.player2SwitchBtn}
                            onChange={changePlayer2SwitchBtn}
                            inputProps={{ "aria-label": "controlled" }}
                            color="secondary"
                          />
                        </ThemeProvider>
                        <span
                          className={`${
                            state.player2SwitchBtn ? "flex" : "hidden"
                          } text-white255 text-md ml-[-13px] mr-[10px] font-[Cambay]`}
                        >
                          {"on"}
                        </span>
                      </div>
                      <PrimaryText className={inputTitle}>
                        {t("tournamentCheckout.player2")}
                      </PrimaryText>
                    </div>
                    {CustomInput({
                      title: t("tournamentCheckout.name"),
                      value: state.player2Name,
                      onChange: (event) => {
                        const regex = /^[a-zA-Z\b]+$/;
                        if (
                          event.target.value === "" ||
                          regex.test(event.target.value)
                        ) {
                          setState({ player2Name: event.target.value });
                          saveDetails();
                        }
                      },
                      maxLength: 30,
                      readOnly: state.player2SwitchBtn,
                    })}
                    {CustomInput({
                      title: t("tournamentCheckout.handicap"),
                      value: state.player2Handicap,
                      onChange: (event) => {
                        const regex = /^[0-9+-.\b]+$/;
                        if (
                          event.target.value === "" ||
                          regex.test(event.target.value)
                        ) {
                          setState({ player2Handicap: event.target.value });
                          saveDetails();
                        }
                      },
                      maxLength: 5,
                    })}
                    {CustomInput({
                      title:
                        state.country?.label === "Ireland"
                          ? t("tournamentCheckout.cdhNo")
                          : "PlayerId",
                      value: state.player2CDHNumber,
                      onChange: (event) => {
                        setState({ player2CDHNumber: event.target.value });
                        saveDetails();
                      },
                      maxLength: 25,
                    })}
                  </React.Fragment>
                )}

                {playersPriceList?.length >= 3 && (
                  <React.Fragment>
                    <div className="mb-4 w-full h-auto flex flex-col mt-8">
                      <div className="w-full h-auto flex flex-row gap-x-1 items-center">
                        <PrimaryText className="text-white255 text-lg">
                          {t("tournamentCheckout.sameDetail")}
                        </PrimaryText>
                        <span
                          className={`${
                            state.player3SwitchBtn ? "hidden" : "flex"
                          } text-white255 text-md ml-[10px] mr-[-13px] font-[Cambay]`}
                        >
                          {"off"}
                        </span>
                        <ThemeProvider theme={theme}>
                          <Switch
                            checked={state.player3SwitchBtn}
                            onChange={changePlayer3SwitchBtn}
                            inputProps={{ "aria-label": "controlled" }}
                            color="secondary"
                          />
                        </ThemeProvider>
                        <span
                          className={`${
                            state.player3SwitchBtn ? "flex" : "hidden"
                          } text-white255 text-md ml-[-7px] font-[Cambay]`}
                        >
                          {"on"}
                        </span>
                      </div>
                      <PrimaryText className={inputTitle}>
                        {t("tournamentCheckout.player3")}
                      </PrimaryText>
                    </div>
                    {CustomInput({
                      title: t("tournamentCheckout.name"),
                      value: state.player3Name,
                      onChange: (event) => {
                        const regex = /^[a-zA-Z\b]+$/;
                        if (
                          event.target.value === "" ||
                          regex.test(event.target.value)
                        ) {
                          setState({ player3Name: event.target.value });
                          saveDetails();
                        }
                      },
                      readOnly: state.player3SwitchBtn,
                      maxLength: 30,
                    })}
                    {CustomInput({
                      title: t("tournamentCheckout.handicap"),
                      value: state.player3Handicap,
                      onChange: (event) => {
                        const regex = /^[0-9+-.\b]+$/;
                        if (
                          event.target.value === "" ||
                          regex.test(event.target.value)
                        ) {
                          setState({ player3Handicap: event.target.value });
                          saveDetails();
                        }
                      },
                      maxLength: 5,
                    })}
                    {CustomInput({
                      title:
                        state.country?.label === "Ireland"
                          ? t("tournamentCheckout.cdhNo")
                          : "PlayerId",
                      value: state.player3CDHNumber,
                      onChange: (event) => {
                        setState({ player3CDHNumber: event.target.value });
                        saveDetails();
                      },
                      maxLength: 25,
                    })}
                  </React.Fragment>
                )}

                {playersPriceList?.length >= 4 && (
                  <React.Fragment>
                    <div className="mb-4 w-full h-auto flex flex-col mt-8">
                      <div className="w-full h-auto flex flex-row gap-x-1 items-center">
                        <PrimaryText className="text-white255 text-lg">
                          {t("tournamentCheckout.sameDetail")}
                        </PrimaryText>
                        <span
                          className={`${
                            state.player4SwitchBtn ? "hidden" : "flex"
                          } text-white255 text-md ml-[10px] mr-[-13px] font-[Cambay]`}
                        >
                          {"off"}
                        </span>
                        <ThemeProvider theme={theme}>
                          <Switch
                            checked={state.player4SwitchBtn}
                            onChange={changePlayer4SwitchBtn}
                            inputProps={{ "aria-label": "controlled" }}
                            color="secondary"
                          />
                        </ThemeProvider>
                        <span
                          className={`${
                            state.player4SwitchBtn ? "flex" : "hidden"
                          } text-white255 text-md ml-[-7px] font-[Cambay]`}
                        >
                          {"on"}
                        </span>
                      </div>
                      <PrimaryText className={inputTitle}>
                        {t("tournamentCheckout.player4")}
                      </PrimaryText>
                    </div>
                    {CustomInput({
                      title: t("tournamentCheckout.name"),
                      value: state.player4Name,
                      onChange: (event) => {
                        const regex = /^[a-zA-Z\b]+$/;
                        if (
                          event.target.value === "" ||
                          regex.test(event.target.value)
                        ) {
                          setState({ player4Name: event.target.value });
                          saveDetails();
                        }
                      },
                      readOnly: state.player4SwitchBtn,
                      maxLength: 30,
                    })}
                    {CustomInput({
                      title: t("tournamentCheckout.handicap"),
                      value: state.player4Handicap,
                      onChange: (event) => {
                        const regex = /^[0-9+-.\b]+$/;
                        if (
                          event.target.value === "" ||
                          regex.test(event.target.value)
                        ) {
                          setState({ player4Handicap: event.target.value });
                          saveDetails();
                        }
                      },
                      maxLength: 5,
                    })}
                    {CustomInput({
                      title:
                        state.country?.label === "Ireland"
                          ? t("tournamentCheckout.cdhNo")
                          : "playerId",
                      value: state.player4CDHNumber,
                      onChange: (event) => {
                        setState({ player4CDHNumber: event.target.value });
                        saveDetails();
                      },
                      maxLength: 25,
                    })}
                  </React.Fragment>
                )}
              </div>
            )}
          </InputView>

          <Line />

          <div className="mb-4">
            <PrimaryText className={inputTitle}>
              {t("tournamentCheckout.bookingDetail")}
            </PrimaryText>
          </div>
          <BookingView>
            <div className="w-[50%] h-auto flex flex-col gap-y-4 items-center ">
              <DetailTxt title={t("tournamentCheckout.tournament")} />
              <DetailTxt title={t("tournamentCheckout.competition")} />
              <DetailTxt title={t("tournamentCheckout.bookingDate")} />
              <DetailTxt title={t("tournamentCheckout.holes")} />
              <DetailTxt title={t("tournamentCheckout.noOfPlayer")} />
              <DetailTxt title={t("tournamentCheckout.totalBookingFee")} />
            </div>
            <div className="w-[50%] h-auto flex flex-col gap-y-4 items-center ">
              <DetailText
                title={state.tournamentData?.data?.competitionId?.title}
              />
              <DetailText title={state.tournamentData?.data?.title} />
              <DetailText
                title={moment(state.tournamentData?.teeTime?.time).format(
                  "YYYY-MM-DD / hh:mm"
                )}
              />
              <DetailText title={state.tournamentData?.data?.holesToPlay} />
              <DetailText title={state.tournamentData?.slot?.id} />
              <DetailText title={"€ " + totalPrice} />
            </div>
          </BookingView>

          {state.paymentCondition?.firstPaymentCondition === "Invoice" ||
          !state.isPaymentApplicable ? (
            <></>
          ) : (
            <Elements stripe={stripePromise} options={paymentOptions}>
              <PaymentDetails
                onPayClick={() => setState({ payClick: false })}
                inputComplete={state.payClick}
                formData={state}
              />
            </Elements>
          )}

          <BtnView>
            <Cancle onClick={() => cancle()}>
              <PrimaryText className={"text-white255 text-lg"}>
                {t("checkOut.booking.cancel")}
              </PrimaryText>
            </Cancle>
            <Submit
              type="submit"
              disabled={paymentLoader}
              className={`${
                paymentLoader
                  ? " opacity-75"
                  : "hover:from-primary hover:to-primary hover:cursor-pointer"
              }`}
            >
              {paymentLoader ? (
                <RotatingLines
                  strokeColor="white"
                  strokeWidth="3"
                  animationDuration="0.85"
                  width="30"
                  visible={true}
                />
              ) : (
                <PrimaryText className={"text-white255 text-lg"}>
                  {state.paymentCondition?.firstPaymentCondition ===
                    "Invoice" || !state.isPaymentApplicable
                    ? "Book"
                    : t("checkOut.booking.submit")}
                </PrimaryText>
              )}
            </Submit>
          </BtnView>
        </form>
        <TermAndConditionModal
          openModal={state.termConditionModal}
          closeModal={closeTermConditionModal}
        />
        <PrivacyPolicyModal
          openModal={state.privacyPolicyModal}
          closeModal={closePrivacyPolicyModal}
        />
      </>
    );
  };

  return (
    <Component>
      <CompleteBookingView>
        <div className="mb-[10px]">
          <PrimaryText className="text-white255 text-lg font-semibold uppercase">
            {t("checkOut.completeBooking.completeYourBooking")}
          </PrimaryText>
        </div>
        <div className="w-full h-auto flex flex-col bg-white255b rounded-xl shadow-xl md3:p-4 p-2">
          {BookingForm()}
          <SuccessModal
            openModal={state.successModal}
            closeModal={closeSuccessModal}
          />
        </div>
        {state.alertMessageTxt && (
          <TostMessage
            open={state.alertMessage}
            onClose={() =>
              setState({ alertMessage: false, alertMessageTxt: null })
            }
            title={state.alertMessageTxt}
            type={"info"}
          />
        )}
      </CompleteBookingView>

      <BookingDetailView>
        <ClubDetails />
      </BookingDetailView>
    </Component>
  );
}

const Component = tw.div`
md:px-8 sm:px-4 px-2
mt-4
h-auto
w-full
flex
lg2:flex-row
flex-col
lg2:items-start
items-center
justify-center
gap-x-6
`;
const CompleteBookingView = tw.div`
lg2:w-[72%] w-full 
h-auto 
`;
const BookingDetailView = tw.div`
lg2:w-[28%]
w-full
h-auto
max-w-[360px]
flex
rounded-lg
lg2:mt-0
mt-10
`;
const txtInput = `
w-full 
bg-white255 
text-textColor2 
border-[2px] 
rounded-lg
py-[11px]
mb-[12px]
px-4 
leading-tight 
focus:outline-none 
border-[#ffffff]
shadow-[0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02)]
focus:border-[black]
placeholder:text-[#757680]
`;
const inputTitle = `
text-white255 
text-xl 
font-semibold
`;
const InputView = tw.div`
w-full 
h-auto 
flex  
md3:flex-row  flex-col 
items-start 
justify-between 
gap-x-4 
gap-y-4
`;
const BookingView = tw.div`
lg:w-[65%] w-full 
h-auto 
flex 
flex-row 
items-center 
justify-start 
gap-x-4 
mb-14
`;
const BtnView = tw.div`
flex 
flex-row 
justify-between 
items-cetner
w-full 
h-[46px] 
mt-[60px]
mb-4
`;
const Submit = tw.button`
md:w-[30%] w-fit px-10
h-[44px]
rounded-[23px]
bg-gradient-to-r from-primary to-[#725e40]
flex
justify-center
items-center
webkitHighlight
`;
const Cancle = tw.button`
md:w-[30%] w-fit px-10
h-[44px]
rounded-[23px]
bg-gradient-to-r from-red-400 to-red255
hover:from-red255 hover:to-red255
flex
justify-center
items-center
webkitHighlight
`;
const CheckboxView = tw.div`
w-auto 
h-auto 
flex 
flex-row 
items-center
mt-2
`;
const Line = tw.div`
w-full
h-[1px]
bg-primary
my-8
`;

export default CheckOutForm;
